import { executePost } from "@/services/lukita";

export default function sendChatMessage({
  slug,
  message,
  onResponse,
  aborter,
}) {
  return executePost(
    `/projects/${slug}/prompt_chat`,
    { prompt_chat: { message } },
    { isStream: true, onStreamMessage: onResponse, aborter },
  );
}
